/**
 * @file 平台检测
 * @description 根据运行环境自动检测并返回对应的平台策略
 */

import { isInApp, isInWeChatMiniProgram } from '@h5-journey/utils'
import type { IPlatformStrategy } from './types'
import { createAppStrategy } from './strategies/app'
import { createH5Strategy } from './strategies/h5'
import { createPCStrategy } from './strategies/pc'
import { createMiniProgramStrategy } from './strategies/miniprogram'

/**
 * PC 检测逻辑：
 * - 优先级：构建时环境变量 VITE_PLATFORM 显式指定
 * - 其次：运行时通过 UA 判断（非移动端即为 PC）
 */
function isPC(): boolean {
  // 方式1：构建时环境变量（推荐，确定性最强）
  if (import.meta.env.VITE_PLATFORM === 'pc') return true
  // 方式2：运行时 UA 检测（兼容同一包多端运行场景）
  const ua = navigator.userAgent.toLowerCase()
  const isMobile = /android|iphone|ipad|ipod|mobile/.test(ua)
  return !isMobile
}

/**
 * 检测当前平台并返回对应策略
 * 检测优先级：微信小程序 > APP > PC > H5
 */
export function detectPlatform(): IPlatformStrategy {
  if (isInWeChatMiniProgram()) return createMiniProgramStrategy()
  if (isInApp()) return createAppStrategy()
  if (isPC()) return createPCStrategy()
  return createH5Strategy()
}
